export const TOAST_AUTO_HIDE_DURATION = 5000;

/** Matches the fade-out duration in toast.scss. */
export const TOAST_EXIT_DURATION = 195;

/** Share of the auto-hide duration left after hover or focus ends */
export const TOAST_RESUME_RATIO = 0.5;
